/* eslint-disable no-console */
import React, { useEffect } from 'react';
import { Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { getTenantConfig } from '../../Components/Common/Util';

const ButtonComponent = ({
    currentIndexFromStore,
    assessmentLength,
    handlePrev,
    handleNext,
    handleAnswersSave,
    assessmentCompleted,
    displayPosition,
    showApprove,
    handleApproveOrReject,
    showSubmitIfEmptyPage,
    isDemographic,
    completePage,
    btnForMarriot,
    nextToSubmit,
    disableContinue
}) => {
    const { t } = useTranslation();

    const location = useLocation();
    const tenantConfig = getTenantConfig(isDemographic);

    const isLeftPosition = displayPosition === 'right' ? true : false;

    const btnFn = () => {
        return (
            <>
                {!isLeftPosition ? (
                    <>
                        {currentIndexFromStore !== 0 && (
                            <Button onClick={handlePrev} className="fixed-bottom-right">
                                {t('prev')}
                            </Button>
                        )}
                        {currentIndexFromStore !== assessmentLength - 1 ? (
                            <>
                                <Button onClick={handleNext} className="fixed-bottom-right">
                                    {nextToSubmit === true ? t('assessmentSubmitBtn') : t('next')}
                                    {/* {nextToSubmit ? 'assessmentSubmitBtn' : 'next'} */}
                                </Button>
                                {!showApprove && isDemographic?.toString() === tenantConfig?.REACT_APP_ASSESSMENT_ID && (
                                    <Button onClick={completePage} className="fixed-bottom-right">
                                        {t('SubmitForACallback')}
                                    </Button>
                                )}
                            </>
                        ) : (
                            !assessmentCompleted && (
                                <Button onClick={handleAnswersSave} type="submit" className="fixed-bottom-right">
                                    {t('assessmentSubmitBtn')}
                                </Button>
                            )
                        )}
                        {showSubmitIfEmptyPage && (
                            <Button onClick={handleAnswersSave} type="submit" className="fixed-bottom-right">
                                {t('assessmentSubmitBtn')}
                            </Button>
                        )}
                    </>
                ) : (
                    <>
                        {currentIndexFromStore !== assessmentLength - 1 ? (
                            <Button onClick={handleNext} className="fixed-bottom-right">
                                {nextToSubmit === true ? t('assessmentSubmitBtn') : t('next')}
                                {/* {nextToSubmit ? 'assessmentSubmitBtn' : 'next'} */}
                            </Button>
                        ) : (
                            !assessmentCompleted && (
                                <Button onClick={handleAnswersSave} type="submit" className="fixed-bottom-right">
                                    {t('assessmentSubmitBtn')}
                                </Button>
                            )
                        )}
                        {currentIndexFromStore !== 0 && (
                            <Button onClick={handlePrev} className="fixed-bottom-right">
                                {t('prev')}
                            </Button>
                        )}
                        {showSubmitIfEmptyPage && (
                            <Button onClick={handleAnswersSave} type="submit" className="fixed-bottom-right">
                                {t('assessmentSubmitBtn')}
                            </Button>
                        )}
                    </>
                )}
            </>
        );
    };

    const demographicFn = () => {
        return (
            <>
                {showApprove ? (
                    <Button
                        onClick={handleNext}
                        className="fixed-bottom-right"
                        disabled={tenantConfig.checkForDisableButton ? disableContinue : false}
                    >
                        {t('next')}
                    </Button>
                ) : (
                    <>
                        {currentIndexFromStore === 0 ? (
                            <>
                                {tenantConfig?.umoja ? (
                                    !assessmentCompleted && (
                                        <Button onClick={handleAnswersSave} type="submit" className="fixed-bottom-right">
                                            {t('assessmentSubmitBtn')}
                                        </Button>
                                    )
                                ) : (
                                    <>
                                        <Button
                                            onClick={currentIndexFromStore !== 0 ? handlePrev : handleNext}
                                            disabled={tenantConfig.checkForDisableButton ? disableContinue : false}
                                            className="fixed-bottom-right"
                                        >
                                            {currentIndexFromStore !== 0 ? t('prev') : t('continueAssessment')}
                                        </Button>
                                        <Button onClick={completePage} className="fixed-bottom-right">
                                            {t('SubmitForACallback')}
                                        </Button>
                                    </>
                                )}
                            </>
                        ) : (
                            <>
                                <Button onClick={handlePrev} className="fixed-bottom-right">
                                    {t('prev')}
                                </Button>
                                {!assessmentCompleted && (
                                    <Button onClick={handleAnswersSave} className="fixed-bottom-right">
                                        {t('assessmentSubmitBtn')}
                                    </Button>
                                )}
                            </>
                        )}
                    </>
                )}
            </>
        );
    };

    return (
        <div className="button-container d-flex justify-content-center align-items-center">
            <div
                className={`button-group ${
                    currentIndexFromStore === 0 || currentIndexFromStore === assessmentLength - 1 ? 'single-button' : ''
                }`}
            >
                {isDemographic?.toString() === tenantConfig?.REACT_APP_ASSESSMENT_ID && btnForMarriot ? demographicFn() : btnFn()}
                {showApprove &&
                    isDemographic?.toString() === tenantConfig?.REACT_APP_ASSESSMENT_ID &&
                    currentIndexFromStore === assessmentLength - 1 && (
                        <>
                            <Button
                                onClick={() => handleApproveOrReject('reject')}
                                color="danger"
                                className="bg-danger fixed-bottom-right"
                                disabled={assessmentCompleted}
                            >
                                {'Reject'}
                            </Button>
                        </>
                    )}
            </div>
        </div>
    );
};

export default ButtonComponent;
